<template>
	<div v-if="!profileData.isEntryVirtualSimulationType" class="hud-wrapper">
		<svg
			class="small-shape"
			width="608px"
			height="142px"
			viewBox="0 0 608 142"
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink"
		>
			<defs>
				<path
					id="path-1"
					d="M237,75.0034614 C237,90.2744075 241.821372,104.41929 250.024977,115.999004 L72,115.998986 C49.90861,115.998986 32,98.0903764 32,75.9989864 L32,74.0009966 C32,51.9096066 49.90861,34.0009966 72,34.0009966 L250.031294,33.9990035 C241.823847,45.580373 237,59.7285961 237,75.0034614 Z M542,34.0009966 C564.09139,34.0009966 582,51.9096066 582,74.0009966 L582,75.9989864 C582,98.0903764 564.09139,115.998986 542,115.998986 L365.975023,115.999004 C374.178628,104.41929 379,90.2744075 379,75.0034614 C379,59.7285961 374.176153,45.580373 365.968706,33.9990035 L542,34.0009966 Z"
				></path>
				<filter
					id="filter-2"
					x="-9.5%"
					y="-45.7%"
					width="119.1%"
					height="228.0%"
					filterUnits="objectBoundingBox"
				>
					<feOffset
						dx="0"
						dy="15"
						in="SourceAlpha"
						result="shadowOffsetOuter1"
					></feOffset>
					<feGaussianBlur
						stdDeviation="15"
						in="shadowOffsetOuter1"
						result="shadowBlurOuter1"
					></feGaussianBlur>
					<feComposite
						in="shadowBlurOuter1"
						in2="SourceAlpha"
						operator="out"
						result="shadowBlurOuter1"
					></feComposite>
					<feColorMatrix
						values="0 0 0 0 0   0 0 0 0 0.298039216   0 0 0 0 0.815686275  0 0 0 0.24 0"
						type="matrix"
						in="shadowBlurOuter1"
					></feColorMatrix>
				</filter>
			</defs>
			<g
				id="Symbols"
				stroke="none"
				stroke-width="1"
				fill="none"
				fill-rule="evenodd"
			>
				<g
					id="assets-/-hud-/-small"
					transform="translate(-3.000000, -19.000000)"
				>
					<g id="small">
						<use
							fill="black"
							fill-opacity="1"
							filter="url(#filter-2)"
							xlink:href="#path-1"
						></use>
						<path
							stroke="#DDE4E6"
							stroke-width="1"
							d="M249.071997,34.4990142 L72,34.5009966 C50.1847524,34.5009966 32.5,52.1857489 32.5,74.0009966 L32.5,75.9989864 C32.5,97.814234 50.1847524,115.498986 72.0000001,115.498986 L249.065866,115.499004 C240.929758,103.682477 236.5,89.6749571 236.5,75.0034614 C236.5,60.3282241 240.932026,46.3173352 249.072015,34.4990134 Z M366.927985,34.4990135 C375.067974,46.3173353 379.5,60.3282242 379.5,75.0034614 C379.5,89.6749571 375.070242,103.682477 366.934116,115.499005 L542,115.498986 C563.815248,115.498986 581.5,97.814234 581.5,75.9989864 L581.5,74.0009966 C581.5,52.1857489 563.815248,34.5009966 542,34.5009966 L366.928003,34.4990143 Z"
							stroke-linejoin="square"
							fill="#FFFFFF"
							fill-rule="evenodd"
						></path>
					</g>
				</g>
			</g>
		</svg>
		<slot></slot>
	</div>

	<div v-else class="hud-wrapper-budget">
		<svg
			class="budget-shape"
			width="273px"
			height="142px"
			viewBox="0 0 273 142"
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink"
		>
			<defs>
				<path
					id="path-1"
					d="M247.031294,14.9990035 C238.823847,26.580373 234,40.7285961 234,56.0034614 C234,71.2744075 238.821372,85.4192896 247.024977,96.9990045 L69,96.9989864 C46.90861,96.9989864 29,79.0903764 29,56.9989864 L29,55.0009966 C29,32.9096066 46.90861,15.0009966 69,15.0009966 L247.031294,14.9990035 Z"
				></path>
				<filter
					id="filter-2"
					x="-24.1%"
					y="-45.7%"
					width="148.2%"
					height="228.0%"
					filterUnits="objectBoundingBox"
				>
					<feOffset
						dx="0"
						dy="15"
						in="SourceAlpha"
						result="shadowOffsetOuter1"
					></feOffset>
					<feGaussianBlur
						stdDeviation="15"
						in="shadowOffsetOuter1"
						result="shadowBlurOuter1"
					></feGaussianBlur>
					<feComposite
						in="shadowBlurOuter1"
						in2="SourceAlpha"
						operator="out"
						result="shadowBlurOuter1"
					></feComposite>
					<feColorMatrix
						values="0 0 0 0 0   0 0 0 0 0.298039216   0 0 0 0 0.815686275  0 0 0 0.24 0"
						type="matrix"
						in="shadowBlurOuter1"
					></feColorMatrix>
				</filter>
			</defs>
			<g
				id="Symbols"
				stroke="none"
				stroke-width="1"
				fill="none"
				fill-rule="evenodd"
			>
				<g
					id="assets-/-hud-/-Combined-Shape"
					transform="translate(-3.000000, -19.000000)"
				>
					<g id="Combined-Shape">
						<use
							fill="black"
							fill-opacity="1"
							filter="url(#filter-2)"
							xlink:href="#path-1"
						></use>
						<path
							stroke="#DDE4E6"
							stroke-width="1"
							d="M246.071997,15.4990142 L69,15.5009966 C47.1847524,15.5009966 29.5,33.1857489 29.5,55.0009966 L29.5,56.9989864 C29.5,78.814234 47.1847524,96.4989864 69.0000001,96.4989864 L246.065866,96.4990044 C237.929758,84.6824767 233.5,70.6749571 233.5,56.0034614 C233.5,41.3282241 237.932026,27.3173352 246.072015,15.4990134 Z"
							stroke-linejoin="square"
							fill="#FFFFFF"
							fill-rule="evenodd"
						></path>
					</g>
				</g>
			</g>
		</svg>
		<slot></slot>
	</div>
</template>
<script>
import ProfileData from '@/mixins/ProfileData';

export default { mixins: [ProfileData] };
</script>
<style lang="scss" scoped>
.hud-wrapper {
	position: relative;
}
.hud-wrapper-budget {
	position: relative;
	margin-left: 250px;
	//margin-bottom: -30px;
	.budget-shape {
		margin-right: 350px;
		margin-top: 20px;
	}
}
</style>
